import { ParsedUrlQueryInput } from 'querystring';

import { SearchViewModel } from '@api/index';

export interface ITourSearchBarState {
  searchData: SearchViewModel | null;
  href: string;
  isSearchDataError: boolean;
  allResultsURL?: {
    query: string | ParsedUrlQueryInput | null | undefined;
    pathname: string;
  };
}

export enum TourSearchBarActionType {
  SET_SEARCH_DATA = 'SetTourSearchData',
  SET_HREF = 'SetTourHref',
  SET_ALL = 'SetTourAll',
  SET_IS_SEARCH_DATA_ERROR = 'SetTourIsSearchDataError',
  SET_ALL_RESULTS_URL = 'SetTourAllResultsUrl',
}

export interface SetSearchData {
  type: TourSearchBarActionType.SET_SEARCH_DATA;
  payload: ITourSearchBarState['searchData'];
}

export interface SetHref {
  type: TourSearchBarActionType.SET_HREF;
  payload: ITourSearchBarState['href'];
}

export interface SetAll {
  type: TourSearchBarActionType.SET_ALL;
  payload: ITourSearchBarState;
}

export interface SetIsSearchDataError {
  type: TourSearchBarActionType.SET_IS_SEARCH_DATA_ERROR;
  payload: ITourSearchBarState['isSearchDataError'];
}

export interface SetTourAllResultsUrl {
  type: TourSearchBarActionType.SET_ALL_RESULTS_URL;
  payload: ITourSearchBarState['allResultsURL'];
}
export type TourSearchBarActions =
  | SetSearchData
  | SetHref
  | SetAll
  | SetIsSearchDataError
  | SetTourAllResultsUrl;
